module.exports = __webpack_public_path__ + "img/1006_sp.03722d4e.gif";